/// <reference path="../../lib/tsd.d.ts" />
/// <reference path="./utils.ts" />

import {ChatClientUI} from "./view";

/**
 * A handler class of the volume related ui components.
 * Provides methods and a callback to update and query the volume
 * slider and the toggle button.
 *
 * Note: This class is not responsible to interact with the receiver
 * so setting the volume will not actually set it, it just updates the
 * slider. :)
 */
export class VolumeSlider
{
	private $slider : JQuery;
	private $slider2 : JQuery;
	private $toggle : JQuery;
	private $handle : JQuery;

	private volume : number;
	private muted  : boolean;

	/**
	 * @param $root  A node that contains the buttons and sliders related to volume
	 *               control. This class expect the slider to be vertical.
	 *
	 * @param onChangeCallback  A callback that will be called every time the volume
	 *                          is updated by either of the sliders or the toggle
	 *                          buttons.
     */
	constructor($root : JQuery, $view : ChatClientUI, private onChangeCallback : (number, boolean) => void)
	{
		// Prepare DOM

		this.$slider = $root.find(".sxccv-slider");
		this.$slider2 = $root.find(".sxccv-slider2");
		this.$toggle = $root.find(".sxccv-toggle");
		this.$handle = $root.find(".sxccv-handle");

		// Handle toggle button(s)

		this.$toggle.on("click", () => {
			let defaultVolume = $view.storage.get("defaultVolume", 50);
			if(defaultVolume == 0) { defaultVolume = 50; }

			let mutedState = !this.muted;

			this.setVolume(((mutedState === false) ? defaultVolume : null), mutedState);
			this.update();
			this.emitChangeEvent();
		});

		// Handle slider(s)

		// Clicking on the slider should set the volume to that specific point

		this.$slider.on('mousedown', (e) =>
		{
			let sh = this.$slider.height();

			$(document).on('mouseup.sxcVolumeSliderModule', (e) =>
			{
				$(document)
					.off('mouseup.sxcVolumeSliderModule')
					.off('mousemove.sxcVolumeSliderModule');

				let fromTop = e.pageY - this.$slider.offset().top;
				this.volume = Math.round(100 - Math.min(100, Math.max(0, fromTop / sh * 100)));
				if (this.volume) this.muted = false;
				this.update();
				this.emitChangeEvent();
			});

			$(document).on('mousemove.sxcVolumeSliderModule', (e) =>
			{
				let fromTop = e.pageY - this.$slider.offset().top;
				this.volume = Math.round(100 - Math.min(100, Math.max(0, fromTop / sh * 100)));
				if (this.volume) this.muted = false;
				this.update();
			});
		});

		this.muted = false;
		this.volume = 50;
		this.update();
	}

	/**
	 * Sets the volume and the muted status
	 * If either of the values are null, that value won't be updated
	 *
	 *
	 * @param volume
	 * @param muted
	 */
	setVolume(volume : number, muted : boolean)
	{
		if (volume !== null) this.volume = volume;
		if (muted !== null) this.muted = muted;

		this.update();
	}

	private update()
	{
		let volClass;

		if (this.muted || this.volume === 0) volClass = "sxcc-icon-vol0";
		else if (this.volume > 70) volClass="sxcc-icon-vol2";
		else volClass="sxcc-icon-vol1";

		this.$toggle.find("i")
			.removeClass("sxcc-icon-vol0 sxcc-icon-vol1 sxcc-icon-vol2")
			.addClass(volClass);

		this.$handle.css("bottom", (!this.muted ? this.volume : 0) + "%");
		this.$slider2.css("height", (!this.muted ? this.volume : 0) + "%");

	}

	private emitChangeEvent()
	{
		this.onChangeCallback(this.volume, this.muted);
	}
}
